/* eslint-disable react/jsx-key */
import React, { useContext, useState } from 'react'
import { strCol, dateCol } from '@integec/grid-tools/lib/cols'
// eslint-disable-next-line no-unused-vars
import moment from 'moment'
import { getApiTargetInfo, UtilityUnitSelection } from 'core'
import { connect } from 'react-redux'
import {
  marginPnodeZoneAEP,
  marginPnodeZoneUpdateAEP,
  marginPnodeZoneDeleteAEP,
} from 'api/pgads.js'
import {
  getEventTypes,
  getUtilityNameMap,
  getUnitNameMap,
} from 'core/selectors'

import { Button, Input, DatePicker } from 'antd'
import styled from 'styled-components'
import CommonScreen from 'admin/component/CommonScreen'
import {
  modifierCol,
  modifiedDateCol,
  utilityHeader,
  unitIdHeader,
} from 'core/HeaderColTypeProps'
import { PNodeZoneContext } from 'context'

const TableTD = styled.div`
  text-align: end;
  max-width: 100px;
  width: 100px;
  display: grid;
  align-content: center;
`

const retrieveTask = apiTargetInfo => marginPnodeZoneAEP(apiTargetInfo)

const modifyTask = apiTargetInfo => data =>
  marginPnodeZoneUpdateAEP(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  marginPnodeZoneDeleteAEP(apiTargetInfo)(data)

const title = 'PNode Zone'

// eslint-disable-next-line no-unused-vars
const MarginPnodeZoneAEP = ({ utilityNameMap, unitNameMap, ...props }) => {
  const [insertEvent, setInsertEvent] = useState(false)

  const { loadPNodeZone } = useContext(PNodeZoneContext)

  const headerWithFormatter = OaMaPnodeZoneHeaders.map(header =>
    header.ident === 'utility'
      ? {
          ...header,
          // ...toSelectionColProps(utilityNameMap),
          dataFormatter: ({ value }) => utilityNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            utilityNameMap[rowData.utility] || rowData.utility,
        }
      : header.ident === 'unitId'
      ? {
          ...header,
          // choices: [],
          dataFormatter: ({ value }) => unitNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            unitNameMap[rowData.unitId] || rowData.unitId,
        }
      : header
  )

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns:
            '100px 200px 100px 200px 100px 150px 100px 150px 150px',
          width: '100%',
          gap: '10px',
        }}
      >
        <TableTD>Unit :</TableTD>
        <div style={{ gridColumnEnd: 'span 3' }}>
          <UtilityUnitSelection
            casStyle={{ width: '100%' }}
            utility={insertData.utility}
            unit={insertData.unit}
            onUnitChange={value => {
              // setUtilityUnit(value)
              setInsertData({
                ...insertData,
                utility: value[0],
                unit: value[1].substr(value[0].length),
                unitId: value[1],
              })
            }}
          />
        </div>

        <TableTD> Effective Date :</TableTD>

        <DatePicker
          style={{ width: '100%' }}
          allowClear
          format="MM/DD/YYYY"
          value={insertData.effectiveDateMoment}
          onChange={d => {
            setInsertData({
              ...insertData,
              effectiveDateMoment: d,
              effectivedate: d.format('YYYY-MM-DD'),
            })
          }}
        />

        <TableTD>Pnode Id :</TableTD>
        <Input
          value={insertData.pnodeid}
          onChange={e =>
            setInsertData({ ...insertData, pnodeid: e.target.value })
          }
        />
        <div />
        <TableTD>EMKT Id :</TableTD>
        <Input
          value={insertData.emktid}
          onChange={e =>
            setInsertData({ ...insertData, emktid: e.target.value })
          }
        />
        <TableTD>Rollup Emkt Id :</TableTD>
        <Input
          value={insertData.rollupEmktid}
          onChange={e =>
            setInsertData({ ...insertData, rollupEmktid: e.target.value })
          }
        />
        <TableTD>PFCT PNode Id :</TableTD>
        <Input
          value={insertData.pfctPnodeId}
          onChange={e =>
            setInsertData({ ...insertData, pfctPnodeId: e.target.value })
          }
        />

        <Button type="primary" onClick={() => onAdd(true)}>
          Add
        </Button>
        <Button
          type="primary"
          onClick={() => onAdd(false)}
          style={{ marginLeft: '20px' }}
        >
          Add & Hide
        </Button>
        <Button type="danger" onClick={onCancel} style={{ marginLeft: '20px' }}>
          Cancel
        </Button>
      </div>
    )
  }

  const onRetrieveData = _ => loadPNodeZone()

  return (
    <CommonScreen
      isAdminScreen={false}
      title={title}
      header={headerWithFormatter}
      saveTask={modifyTask}
      retrieveTask={retrieveTask}
      deleteTask={deleteTask}
      altBy={d => d.utility}
      autoRetrieve
      // sortOptions={headerWithFormatter}
      sortOptions={[utilityHeader, unitIdHeader]}
      initialSortOptions={[utilityHeader, unitIdHeader]}
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={30}
      // widthOffset={550}
      // heightOffset={100}
      onRetrieveData={onRetrieveData}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  eventTypes: getEventTypes(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  // utilityUnitMap: getUtilityUnitsMap(state),
  // units: getUnits(state),
})

export default connect(mapStateToProps)(MarginPnodeZoneAEP)

const OaMaPnodeZoneHeaders = [
  // strCol({ ident: 'utility', display: 'Utility', isKey: true }),
  // strCol({ ident: 'unit', display: 'Unit', isKey: true }),
  utilityHeader,
  unitIdHeader,
  dateCol({
    ident: 'effectivedate',
    display: 'Effective Date',
    isKey: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'pnodeid',
    display: 'PNode Id',
    isFiltered: true,
    width: 200,
    // sortOrder: 'asc',
  }),
  strCol({
    ident: 'emktid',
    display: 'Emkt Id',
    isFiltered: true,
    width: 200,
    // sortOrder: 'asc',
  }),
  strCol({
    ident: 'rollupEmktid',
    display: 'Rollup Emkt Id',
    isFiltered: true,
    width: 200,
    // sortOrder: 'asc',
  }),
  strCol({
    ident: 'pfctPnodeId',
    display: 'PFCT PNode Id',
    isFiltered: true,
    width: 200,
    // sortOrder: 'asc',
  }),
  modifierCol,
  modifiedDateCol,
]
